// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  userList: [],
};

const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    usersSuccess(state, action) {
      state.userList = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
export const { hasError, usersSuccess } = slice.actions;

// ----------------------------------------------------------------------
// ✅ GET Users List
export function getUsersList(payload) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `/users?skip=${payload?.skip || 0}&limit=${payload?.limit || 50}`
      );
      if (response?.data) {
        dispatch(usersSuccess(response.data));
      }
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ CREATE User
export function postUser(formData) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/users`, formData);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ UPDATE User
export function putUser(payload) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`/users/${payload?.username}`, payload);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ DELETE User
export function deleteUser(payload) {
  return async (dispatch) => {
    try {
      const response = await axios.delete(`/users/${payload?.userId}`);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ Upload Users via CSV (optional, if API exists)
export function uploadUsersCSV(payload) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/users/csv`, payload);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ Download Users CSV (optional, if API exists)
export function downloadUsersCSV() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/users/csv`);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ Request 2FA
export function request2FA(username, payload) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/users/${username}/2fa/request`, payload);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ✅ Verify 2FA
export function verify2FA(username, otp) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/users/${username}/2fa/verify?otp=${otp}`);
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}
